var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOutlineCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.333 2.91699C15.7472 2.91699 16.083 3.25278 16.083 3.66699V4.58301H17.833C19.1676 4.58301 20.2498 5.66545 20.25 7L20.25 18.666C20.25 20.0007 19.1677 21.083 17.833 21.083L6.16699 21.083C4.8323 21.083 3.75 20.0007 3.75 18.666L3.75 7C3.75016 5.66545 4.83241 4.58301 6.16699 4.58301L7.91699 4.58301V3.66699C7.91699 3.25278 8.25278 2.91699 8.66699 2.91699C9.08106 2.91717 9.41699 3.25289 9.41699 3.66699V4.58301L14.583 4.58301V3.66699C14.583 3.25289 14.9189 2.91717 15.333 2.91699ZM5.25 11.083L5.25 18.666C5.25 19.1723 5.66073 19.583 6.16699 19.583L17.833 19.583C18.3393 19.583 18.75 19.1723 18.75 18.666V11.083L5.25 11.083ZM6.16699 6.08301C5.66083 6.08301 5.25016 6.49388 5.25 7V9.58301L18.75 9.58301V7C18.7498 6.49388 18.3392 6.08301 17.833 6.08301H16.083V7C16.0828 7.41407 15.7471 7.75 15.333 7.75C14.919 7.74982 14.5832 7.41396 14.583 7V6.08301L9.41699 6.08301V7C9.41683 7.41396 9.08095 7.74982 8.66699 7.75C8.25288 7.75 7.91716 7.41407 7.91699 7V6.08301L6.16699 6.08301Z",
    fill: "#FF6600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutlineCalendar);
export default __webpack_public_path__ + "static/media/icon-outline-calendar.cf7297694ca863043ecf85d0235bc4db.svg";
export { ForwardRef as ReactComponent };